// @flow
import React from 'react';
import classNames from 'classnames';

type Props = {
  position: 1 | 2,
  isValidated: boolean,
  isErrored: boolean,
};

export const BirthDateInputSeparator = ({ position, isValidated, isErrored }: Props) => (
  <span
    style={{ left: `${(position / 3) * 100}%` }}
    className={classNames('pointer-events-none absolute flex h-9 items-center', {
      'text-emerald': isValidated,
      'text-red': isErrored,
    })}
  >
    /
  </span>
);
